import cn from "classnames";

export const OnOffLabel = ({ on }: { on: boolean }) => (
  <div
    className={cn(
      "rounded-sm",
      "text-base font-normal",
      "px-1 py-0 flex gap-1 justify-center items-center w-fit",
      on ? "text-black bg-lime-400" : "text-black bg-black-200",
    )}
  >
    {on ? "ON" : "OFF"}
  </div>
);
